import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController, NavParams, PopoverController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { GatewayKindGroup } from "src/model/class/general classes/gateway-kind-group";
import { ChartSerieKind } from "src/components/shared-components/enum/enumChart";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";

@Component({
    selector: "app-popover-object-info",
    templateUrl: "./popover-object-info.component.html",
    styleUrls: ["./popover-object-info.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopoverObjectInfoComponent implements OnInit, OnDestroy, iEvent {
  public _eventSubscriptions: Array<Subscription> = null;

  public objChartKindIsBar: boolean = false;

  @Input() objGatewayGroup: GatewayKindGroup;
  @Input() objChartKind;
  @Input() objWeeklyPlanning;
  @Input() fromCustomInterface;

  constructor(
    private _popoverController: PopoverController,
    private _eventService: EventService
  ) { }

  ngOnInit() {
    this.subscribeEvents();
    if (this.objChartKind) {
      this.objChartKindIsBar = this.objChartKind == ChartSerieKind.BAR;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._popoverController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  itemChartClick(operation: string) {
    this._popoverController.dismiss(operation);
  }

  itemWeeklyPlanningClick(operation: string) {
    this._popoverController.dismiss(operation);
  }
}
